import { render, staticRenderFns } from "./CreateConteudo.vue?vue&type=template&id=6abe9720&scoped=true&"
import script from "./CreateConteudo.vue?vue&type=script&lang=js&"
export * from "./CreateConteudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abe9720",
  null
  
)

export default component.exports